import { createSignal, type Accessor } from "solid-js";
import type { AggregatedMetrics } from "@storytell/streaming";

/**
 * Hook for managing credits display state and tooltip
 */
export const useCreditsDisplay = (accumulatedMetrics?: Accessor<AggregatedMetrics | undefined>) => {
  const [showTooltip, setShowTooltip] = createSignal(false);
  const [showPricingModal, setShowPricingModal] = createSignal(false);

  // Get balance from streaming metrics or fallback to mock data
  const balance = () => accumulatedMetrics?.()?.balance ?? 1709;
  const dailyCredits = () => 30; // Static daily credits for now
  const planType = () => "Free"; // Static plan type for now
  // For credits display, we use the balance (which represents current available credits)
  const credits = () => balance();
  const totalCredits = () => balance() + dailyCredits();

  const toggleTooltip = () => {
    setShowTooltip(!showTooltip());
  };

  const hideTooltip = () => {
    setShowTooltip(false);
  };

  const openPricingModal = () => {
    setShowPricingModal(true);
    hideTooltip(); // Hide tooltip when opening modal
  };

  const closePricingModal = () => {
    setShowPricingModal(false);
  };

  return {
    showTooltip,
    setShowTooltip,
    toggleTooltip,
    hideTooltip,
    showPricingModal,
    openPricingModal,
    closePricingModal,
    credits,
    dailyCredits,
    planType,
    totalCredits,
  };
};
